
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/registration",
      function () {
        return require("private-next-pages/auth/registration.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/registration"])
      });
    }
  